import { bl_fi_slsodr_to_slsinv_consol_run_line_RowClass } from "../../dbschema/bl_fi_slsodr_to_slsinv_consol_run_line.model";
import { BaseContainerModel } from "../base-container.model";

export class SOConsolidationRunLineModel extends BaseContainerModel {
  bl_fi_slsodr_to_slsinv_consol_run_line: bl_fi_slsodr_to_slsinv_consol_run_line_RowClass =
    new bl_fi_slsodr_to_slsinv_consol_run_line_RowClass();
}
